import React from 'react';

const CookiesPolicy = () => {
    const supportEmail = "support@shopysync.com";
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">

                    {/* Header */}
                    <h1 className="display-5 fw-bold text-teal mb-4">Cookies Policy</h1>
                    <p className="text-muted mb-5">Last updated: January 22, 2026</p>

                    {/* 1. We Do NOT Use Cookies */}
                    <section className="mb-5 p-4 bg-light rounded shadow-sm text-center">
                        <h2 className="h5 fw-bold text-teal mb-3">We Do NOT Use Cookies</h2>
                        <p className="mb-0 text-muted" style={{ fontSize: '1.1rem' }}>
                            <strong>Shopy Sync does not set or read any cookies.</strong><br />
                            The app runs inside your Shopify admin using secure OAuth — no cookies are involved.
                        </p>
                    </section>

                    {/* 2. Third-Party Cookies */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">Third-Party Cookies (Shopify & Google)</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', Optionally: '1.7' }}>
                            When using Shopy Sync:
                        </p>
                        <ul className="list-unstyled text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                            <li className="mb-2">• <strong>Shopify</strong> may set cookies for login and session management.</li>
                            <li className="mb-2">• <strong>Google</strong> may set cookies when you connect your Google Sheet.</li>
                        </ul>
                        <p className="text-muted mt-3 small">
                            These are controlled by Shopify and Google — not by us.<br />
                            View their policies:
                            <br />• <a href="https://www.shopify.com/legal/cookies" target="_blank" rel="noopener noreferrer" className="text-teal">Shopify Cookies</a>
                            <br />• <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="text-teal">Google Cookies</a>
                        </p>
                    </section>

                    {/* 3. Local Storage (Not Cookies) */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">We Use Local Storage (Not Cookies)</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            To remember your preferences, we use <strong>browser local storage</strong>:
                        </p>
                        <ul className="list-unstyled text-muted small">
                            <li>• Selected Google Sheet ID</li>
                            <li>• Column mapping settings</li>
                            <li>• Sync preferences</li>
                        </ul>
                        <p className="text-muted mt-3">
                            <strong>This is NOT a cookie.</strong> It is cleared when you:
                            <br />→ Uninstall the app
                            <br />→ Clear browser data
                        </p>
                    </section>

                    {/* 4. No Tracking */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">No Tracking or Analytics</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            We do <strong>not</strong> use:
                            <br />• Google Analytics
                            <br />• Facebook Pixel
                            <br />• Any advertising or tracking tools
                        </p>
                    </section>

                    {/* 5. Your Control */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">You Are in Full Control</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            • No cookie banner needed<br />
                            • No consent required<br />
                            •  Revoke access anytime via Shopify or Google settings
                        </p>
                    </section>

                    {/* 6. Changes & Contact */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">Need Help?</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            Email us:
                            <a
                                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}&su=Support Request - Shopy Sync`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-teal"
                                style={{ marginLeft: '5px' }}
                            >
                                {supportEmail}
                            </a>
                        </p>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default CookiesPolicy;